// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"5acf2efe","377":"be5c45f5","384":"13a12659","434":"6f8e838c","530":"efd46b24","666":"8494d2bf","811":"f78b035d"}[chunkId] + ".chunk.js";
};